module.exports = __webpack_public_path__ + "static/img/CXGheader.c9f560e4.png";